import { alpha } from '@mui/material/styles';

// CoreUI color system
export const primary = {
  lighter: '#d8e7fb',
  light: '#69a5f7',
  main: '#321fdb',  // CoreUI primary
  dark: '#2819ae',
  darker: '#1f1382',
  contrastText: '#fff',
};

export const secondary = {
  lighter: '#d6d8db',
  light: '#9da5b1',
  main: '#9da5b1',  // CoreUI secondary
  dark: '#7d848e',
  darker: '#5c636a',
  contrastText: '#fff',
};

export const info = {
  lighter: '#d6e7f7',
  light: '#67b7f7',
  main: '#39f',    // CoreUI info
  dark: '#2982cc',
  darker: '#1f6299',
  contrastText: '#fff',
};

export const success = {
  lighter: '#d5f1de',
  light: '#69db7c',
  main: '#2eb85c',  // CoreUI success
  dark: '#25934a',
  darker: '#1c6e37',
  contrastText: '#fff',
};

export const warning = {
  lighter: '#fff3cd',
  light: '#ffe69c',
  main: '#f9b115',  // CoreUI warning
  dark: '#c78e11',
  darker: '#956a0e',
  contrastText: '#000',
};

export const danger = {
  lighter: '#f8d7da',
  light: '#f1aeb5',
  main: '#e55353',  // CoreUI danger
  dark: '#b74242',
  darker: '#893232',
  contrastText: '#fff',
};

export const light = {
  main: '#ebedef',  // CoreUI light
  contrastText: '#000',
};

export const dark = {
  main: '#4f5d73',  // CoreUI dark
  contrastText: '#fff',
};

// Grays
export const grey = {
  0: '#fff',
  100: '#ebedef',
  200: '#d8dbe0',
  300: '#c4c9d0',
  400: '#b1b7c1',
  500: '#9da5b1',
  600: '#8a93a2',
  700: '#768192',
  800: '#636f83',
  900: '#4f5d73',
};

// Default colors
export const common = {
  black: '#000000',
  white: '#FFFFFF',
};

// Action colors
export const action = {
  hover: alpha(grey[500], 0.08),
  selected: alpha(grey[500], 0.16),
  disabled: alpha(grey[500], 0.8),
  disabledBackground: alpha(grey[500], 0.24),
  focus: alpha(grey[500], 0.24),
  hoverOpacity: 0.08,
  disabledOpacity: 0.48,
  active: grey[600],
};

const palette = {
  common,
  primary,
  secondary,
  info,
  success,
  warning,
  danger,
  light,
  dark,
  grey,
  divider: alpha(grey[500], 0.24),
  text: {
    primary: grey[800],
    secondary: grey[600],
    disabled: grey[500],
  },
  background: {
    paper: '#fff',
    default: '#fff',
    neutral: grey[100],
  },
  action,
};

export default palette; 